import React, { useState } from "react";
import UserManagement from "./UserManagement";
import DesignationManagement from "./DesignationManagement";
import { MdSupervisedUserCircle, MdSettings, MdWork } from "react-icons/md";

const Settings = ({ user }) => {
    const [activeTab, setActiveTab] = useState("users");

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="bg-white shadow rounded-lg p-6 flex flex-col md:flex-row justify-between items-start md:items-center">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Settings & Administration</h1>
                    <p className="text-sm text-gray-500 mt-1">
                        Manage system users, designations, access roles, and portal settings.
                    </p>
                </div>
            </div>

            {/* Navigation Tabs */}
            <div className="border-b border-gray-200 bg-white shadow rounded-lg px-4 pt-2">
                <nav className="-mb-px flex space-x-6 overflow-x-auto">
                    <button
                        onClick={() => setActiveTab("users")}
                        className={`py-4 px-3 inline-flex items-center gap-2 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                            activeTab === "users"
                                ? "border-blue-600 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                        <MdSupervisedUserCircle className="w-5 h-5" />
                        User Management
                    </button>

                    <button
                        onClick={() => setActiveTab("designations")}
                        className={`py-4 px-3 inline-flex items-center gap-2 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                            activeTab === "designations"
                                ? "border-blue-600 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                        <MdWork className="w-5 h-5" />
                        Designation / Role Management
                    </button>

                    <button
                        onClick={() => setActiveTab("general")}
                        className={`py-4 px-3 inline-flex items-center gap-2 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
                            activeTab === "general"
                                ? "border-blue-600 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                        <MdSettings className="w-5 h-5" />
                        General Settings
                    </button>
                </nav>
            </div>

            {/* Tab Contents */}
            {activeTab === "users" && (
                <div className="bg-white shadow rounded-lg p-6">
                    <UserManagement />
                </div>
            )}

            {activeTab === "designations" && (
                <div className="bg-white shadow rounded-lg p-6">
                    <DesignationManagement />
                </div>
            )}

            {activeTab === "general" && (
                <div className="bg-white shadow rounded-lg p-6 space-y-6">
                    <h2 className="text-lg font-bold text-gray-800 border-b pb-3">System Information</h2>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                            <h3 className="text-sm font-semibold text-gray-700 mb-2">Portal Information</h3>
                            <p className="text-xs text-gray-600"><strong>Name:</strong> Newsmedia Association of India (NAI)</p>
                            <p className="text-xs text-gray-600 mt-1"><strong>Domain:</strong> naiindia.in</p>
                            <p className="text-xs text-gray-600 mt-1"><strong>Logged In User:</strong> {user?.firstname} ({user?.role || "User"})</p>
                        </div>

                        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                            <h3 className="text-sm font-semibold text-gray-700 mb-2">Security & Roles</h3>
                            <p className="text-xs text-gray-500 leading-relaxed">
                                Users with Admin or Super Admin privileges can add new team members, manage account status, issue password reset links, and configure system designations/roles.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Settings;
